import React from "react";
import Paragraph from "../../components/common/Typography/Paragraph";

const BusinessContact = () => {
  const data = [
    { icon: "fi-br-smartphone", value: "0412 345 678" },
    { icon: "fi-sr-phone-call", value: "03 1234 5678" },
    { icon: "fi-sr-envelope", value: "tradesposter@gmail.com" },
    { icon: "fi-sr-globe", value: "www.tradesposter.com" },
    { icon: "fi-brands-google", value: "Google Business Profile" },
  ];
  return (
    <div className="flex flex-col gap-4">
      {data.map((item, idx) => {
        let href = null;
        if (item.icon.includes('envelope')) {
          href = `mailto:${item.value}`;
        } else if (item.icon.includes('globe')) {
          href = item.value.startsWith('http') ? item.value : `https://${item.value}`;
        } else if (item.icon.includes('phone') || item.icon.includes('smartphone')) {
          href = `tel:${item.value.replace(/\s+/g, '')}`;
        } else if (item.icon.includes('google')) {
          href = "https://business.google.com/profile";
        }
        return href ? (
          <a
            key={idx}
            href={href}
            className="flex items-center gap-3 group transition-colors duration-200"
            target={item.icon.includes('globe') || item.icon.includes('google') ? '_blank' : undefined}
            rel={item.icon.includes('globe') || item.icon.includes('google') ? 'noopener noreferrer' : undefined}
          >
            <i className={`fi ${item.icon} text-base flex items-center`}></i>
            <Paragraph variant={"BodyCompact"} className="group-hover:text-primaryblue transition-colors duration-200">{item.value}</Paragraph>
          </a>
        ) : (
          <div key={idx} className="flex items-center gap-3">
            <i className={`fi ${item.icon} text-base flex items-center`}></i>
            <Paragraph variant={"BodyCompact"}>{item.value}</Paragraph>
          </div>
        );
      })}
    </div>
  );
};

export default BusinessContact;
